import {
  Component,
  Input,
  OnInit
}                                            from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { TranslateService }                  from '@ngx-translate/core';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-password-control',
  template: require('./password-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class PasswordControlComponent extends TextControlComponent implements OnInit {
  public minlength     : number;
  private originalValue: string;
  public pattern       : RegExp;

  // Unset by default so password managers still fill sign in; pass new-password for a third party login.
  @Input() autocomplete    : string = null;
  @Input() hint            = this.translateService.instant('GENERAL_SPACE.TITLE.PASSWORD_REQUIREMENTS');
  // Unbounded by default (overrides TextControlComponent's 255); callers cap explicitly via [maxlength].
  @Input() maxlength       : number = null;
  @Input() mustMatch       : string;
  @Input() validatePattern = false;

  constructor (
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit () : void {
    this.minlength = !!this.validatePattern
      ? 8
      : null;

    this.originalValue = this._model;

    this.pattern = !!this.validatePattern
      ? /[A-Z]/
      : null;
  }

  getInvalidMessage ( input : NgModel ) : string {
    if ( this.mustMatch && input.control.errors?.match ) {
      return this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.PASSWORDS_DO_NOT_MATCH');
    }

    return this.translateService.instant('GENERAL_SPACE.TITLE.PASSWORD_REQUIREMENTS');
  }

  getPattern () : RegExp | null {
    return this.shouldValidatePattern()
      ? this.pattern
      : null;
  }

  isInvalidPattern ( input : NgModel ) : boolean {
    return (
      this.shouldValidatePattern()
      || this.mustMatch
    )
      && input.control.dirty
      && (
        input.control.errors?.minlength
        || input.control.errors?.pattern
        || input.control.errors?.match
      );
  }

  shouldShowLabel ( input : NgModel ) : boolean {
    if (!this.label) {
      return false;
    }

    if ( input.control.dirty && input.control.errors?.required ) {
      return true;
    }

    return input.control.pristine || input.control.valid;
  }

  shouldValidatePattern () : boolean {
    return !!this.validatePattern
      && this._model !== this.originalValue;
  }
}
